(() => {
  const qs = (selector, context = document) => context.querySelector(selector);
  const qsa = (selector, context = document) => [...context.querySelectorAll(selector)];

  const menuToggle = qs('[data-menu-toggle]');
  const mobileMenu = qs('[data-mobile-menu]');

  if (menuToggle && mobileMenu) {
    const closeMenu = () => {
      menuToggle.setAttribute('aria-expanded', 'false');
      mobileMenu.classList.remove('is-open');
      document.body.classList.remove('menu-open');
    };

    menuToggle.addEventListener('click', () => {
      const willOpen = menuToggle.getAttribute('aria-expanded') !== 'true';
      menuToggle.setAttribute('aria-expanded', String(willOpen));
      mobileMenu.classList.toggle('is-open', willOpen);
      document.body.classList.toggle('menu-open', willOpen);
    });

    qsa('a', mobileMenu).forEach((link) => link.addEventListener('click', closeMenu));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMenu();
    });
  }

  const formatMoney = (cents, format) => {
    const value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: format || 'EUR'
      }).format(value);
    } catch (_) {
      return `${value.toFixed(2)} €`;
    }
  };

  qsa('[data-variant-select]').forEach((select) => {
    const form = select.closest('form');
    const container = select.closest('[data-product-container]');
    const prices = container ? qsa('[data-product-price]', container) : [];
    const button = form ? qs('[type="submit"]', form) : null;

    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (option.dataset.price) {
        prices.forEach((price) => {
          price.textContent = option.dataset.price;
        });
      }
      if (button) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        if (button.dataset.availableLabel && button.dataset.soldoutLabel) {
          button.querySelector('[data-button-label]').textContent = available
            ? button.dataset.availableLabel
            : button.dataset.soldoutLabel;
        }
      }
    });
  });

  qsa('form[data-quick-add]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = qs('[type="submit"]', form);
      const status = qs('[data-form-status]', form.parentElement || form);
      const originalLabel = button ? button.innerHTML : '';

      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      }
      if (status) {
        status.textContent = document.body.dataset.cartAdding;
        status.classList.remove('is-error');
      }

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error(document.body.dataset.cartAddFailed);

        const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
        const cart = await cartResponse.json();
        qsa('[data-cart-count]').forEach((count) => {
          count.textContent = cart.item_count;
          count.hidden = cart.item_count === 0;
        });
        if (status) status.textContent = document.body.dataset.cartAdded;
      } catch (error) {
        if (status) {
          status.textContent = document.body.dataset.cartError;
          status.classList.add('is-error');
        }
      } finally {
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.innerHTML = originalLabel;
        }
      }
    });
  });

  qsa('[data-money-cents]').forEach((element) => {
    if (!element.textContent.trim()) {
      element.textContent = formatMoney(element.dataset.moneyCents, element.dataset.currency);
    }
  });
})();
